import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api';
import { IRoutingProfile, IRoutingProfileData } from './routingProfile.interface';

export namespace RoutingProfileAction {
  const actionCreator = actionCreatorFactory('RoutingProfile');

  export const loadList = actionCreator.async<void, IRoutingProfileData, IApiErrorParams>('LOAD_LIST');
  export const create = actionCreator.async<IRoutingProfile, { routingProfileId: IRoutingProfile['id'] }, IApiErrorParams>('CREATE');
  export const update = actionCreator.async<IRoutingProfile, void, IApiErrorParams>('UPDATE');
  export const remove = actionCreator.async<{ routingProfileId: IRoutingProfile['id'] }, void, IApiErrorParams>('REMOVE');

  export const exportFile = actionCreator.async<void, void, IApiErrorParams>('EXPORT_FILE');

  export const destroy = actionCreator('DESTROY');
}
